/**
 * CombiMainsFlow — Animated SVG showing why combis need mains pressure.
 * Contrasts mains-fed instant heating vs gravity-fed inadequacy.
 */

export function CombiMainsFlow() {
  return (
    <figure style={{ margin: 0 }}>
      <svg viewBox="0 0 520 260" width="100%" role="img" aria-label="Why combi boilers need mains pressure">
        <title>Combi boiler: mains pressure vs gravity feed comparison</title>
        <defs>
          <style>{`
            .cmf-pipe { stroke: #64748b; stroke-width: 2.5; fill: none; }
            .cmf-flow-fast { stroke: #3b82f6; stroke-width: 3; fill: none; opacity: 0.6; stroke-dasharray: 8,4; animation: cmf-dash 0.6s linear infinite; }
            .cmf-flow-drip { stroke: #93c5fd; stroke-width: 1.5; fill: none; opacity: 0.3; stroke-dasharray: 2,8; animation: cmf-dash 3s linear infinite; }
            .cmf-label { font-family: system-ui, sans-serif; font-size: 11px; fill: #475569; text-anchor: middle; }
            .cmf-heading { font-family: system-ui, sans-serif; font-size: 13px; fill: #1e293b; font-weight: 600; text-anchor: middle; }
            .cmf-component { fill: #f1f5f9; stroke: #475569; stroke-width: 1.5; }
            .cmf-ok { fill: #dcfce7; stroke: #16a34a; stroke-width: 1.5; }
            .cmf-bad { fill: #fee2e2; stroke: #dc2626; stroke-width: 1.5; }
            .cmf-divider { stroke: #cbd5e1; stroke-width: 1; stroke-dasharray: 4,4; }
            @keyframes cmf-dash { to { stroke-dashoffset: -12; } }
            @keyframes cmf-drip {
              0%, 80% { opacity: 0; }
              85% { opacity: 0.8; transform: translateY(0); }
              100% { opacity: 0; transform: translateY(6px); }
            }
          `}</style>
        </defs>

        <line x1="260" y1="30" x2="260" y2="245" className="cmf-divider" />

        {/* === MAINS FED (left) === */}
        <text x="130" y="20" className="cmp-heading" style={{ fontFamily: 'system-ui, sans-serif', fontSize: '13px', fill: '#1e293b', fontWeight: 600, textAnchor: 'middle' }}>Mains-fed combi</text>

        {/* Mains */}
        <rect x="30" y="60" width="50" height="28" rx="4" className="cmf-ok" />
        <text x="55" y="78" className="cmf-label" style={{ fontSize: '10px' }}>Mains</text>
        <text x="55" y="100" className="cmf-label" style={{ fontSize: '9px', fill: '#16a34a' }}>2+ bar</text>

        {/* Flow to combi */}
        <line x1="80" y1="74" x2="95" y2="74" className="cmf-pipe" />
        <line x1="80" y1="74" x2="95" y2="74" className="cmf-flow-fast" />

        {/* Combi boiler */}
        <rect x="95" y="55" width="70" height="38" rx="6" fill="#dbeafe" stroke="#3b82f6" strokeWidth="2" />
        <text x="130" y="78" className="cmf-label">Combi</text>

        {/* Hot output */}
        <line x1="165" y1="74" x2="210" y2="74" className="cmf-pipe" />
        <line x1="165" y1="74" x2="210" y2="74" className="cmf-flow-fast" />

        {/* Tap — good flow */}
        <rect x="210" y="60" width="30" height="28" rx="4" className="cmf-ok" />
        <text x="225" y="78" className="cmf-label" style={{ fontSize: '18px' }}>🚿</text>

        {/* Flow arrows */}
        <text x="130" y="115" className="cmf-label" style={{ fill: '#16a34a', fontSize: '11px', fontWeight: 600 }}>
          Instant hot water at pressure
        </text>

        {/* Pressure bar visual */}
        <rect x="60" y="130" width="140" height="8" rx="4" fill="#bbf7d0" />
        <rect x="60" y="130" width="120" height="8" rx="4" fill="#16a34a" opacity="0.7" />
        <text x="130" y="152" className="cmf-label" style={{ fontSize: '9px' }}>Pressure maintained through boiler</text>

        {/* === GRAVITY FED (right) === */}
        <text x="390" y="20" style={{ fontFamily: 'system-ui, sans-serif', fontSize: '13px', fill: '#1e293b', fontWeight: 600, textAnchor: 'middle' }}>Gravity-fed combi</text>

        {/* Loft tank */}
        <rect x="290" y="40" width="50" height="22" rx="3" className="cmf-component" />
        <text x="315" y="55" className="cmf-label" style={{ fontSize: '9px' }}>Loft tank</text>

        {/* Gravity drop */}
        <line x1="315" y1="62" x2="315" y2="74" className="cmf-pipe" />
        <line x1="315" y1="62" x2="315" y2="74" className="cmf-flow-drip" />

        {/* Low pressure arrow */}
        <text x="315" y="90" className="cmf-label" style={{ fontSize: '9px', fill: '#dc2626' }}>~0.3 bar</text>

        {/* Combi boiler */}
        <line x1="340" y1="74" x2="355" y2="74" className="cmf-pipe" />
        <rect x="355" y="55" width="70" height="38" rx="6" fill="#fee2e2" stroke="#dc2626" strokeWidth="2" />
        <text x="390" y="78" className="cmf-label">Combi</text>

        {/* Weak output */}
        <line x1="425" y1="74" x2="460" y2="74" className="cmf-pipe" />
        <line x1="425" y1="74" x2="460" y2="74" className="cmf-flow-drip" />

        {/* Tap — weak */}
        <rect x="460" y="60" width="30" height="28" rx="4" className="cmf-bad" />
        <text x="475" y="78" className="cmf-label" style={{ fontSize: '14px' }}>💧</text>

        <text x="390" y="115" className="cmf-label" style={{ fill: '#dc2626', fontSize: '11px', fontWeight: 600 }}>
          Weak trickle — not usable
        </text>

        {/* Pressure bar visual */}
        <rect x="320" y="130" width="140" height="8" rx="4" fill="#fecaca" />
        <rect x="320" y="130" width="25" height="8" rx="4" fill="#dc2626" opacity="0.7" />
        <text x="390" y="152" className="cmf-label" style={{ fontSize: '9px' }}>Insufficient pressure for combi heat exchanger</text>

        {/* Bottom explanation */}
        <rect x="80" y="175" width="360" height="50" rx="8" fill="#f0f9ff" stroke="#bfdbfe" strokeWidth="1" />
        <text x="260" y="195" className="cmf-label" style={{ fontSize: '11px', fill: '#1e40af' }}>
          Combis heat water on demand — no storage.
        </text>
        <text x="260" y="213" className="cmf-label" style={{ fontSize: '11px', fill: '#1e40af' }}>
          Mains pressure drives water through the heat exchanger at speed.
        </text>

        <text x="260" y="245" className="cmf-label" style={{ fontSize: '10px', fill: '#94a3b8' }}>
          If mains is weak, a vented cylinder is the robust alternative
        </text>
      </svg>
    </figure>
  );
}
